import { useEffect, useState } from 'react';
import { ATTACHMENTS_TITLE } from '../shared/AppConstants';
import EntityListComp from './EntityListComp';
import { getEnvVar } from '../utils/getEnvVar';

export default function AttachmentComp(props) {
  const [attachmentData, setAttachmentData] = useState([]);
  const { attachments, userInfoMap, isEdit, commonProps } = props;

  useEffect(() => {
    setAttachmentData(
      attachments
        ?.filter((attachment) => attachment?.visibleOnSummary)
        .sort((a, b) => Date.parse(b?.updatedOn) - Date.parse(a?.updatedOn))
    );
  }, [attachments]);

  return (
    <EntityListComp
      entityData={attachmentData}
      entityName={ATTACHMENTS_TITLE}
      userInfoMap={userInfoMap}
      isEdit={isEdit}
      apiUrl={`${getEnvVar('VITE_GSS_API_URL')}/${commonProps.strategyNumber}/attachments`}
      commonProps={commonProps}
    />
  );
}
